import axios from "axios";

export const isAbortError = (error: unknown): boolean => {
  return axios.isCancel(error) || (error as { code?: string })?.code === "ERR_CANCELED";
};

type ErrorResponseBody = {
  error?: string;
  message?: string;
};
export const getErrorMessage = (error: unknown, fallback: string): string => {
  if (axios.isAxiosError(error)) {
    const data = error.response?.data as ErrorResponseBody | string | undefined;
    if (typeof data === "string" && data.trim()) return data.trim();
    if (data && typeof data === "object") {
      return data.message?.trim() || data.error?.trim() || fallback;
    }
  }
  if (error instanceof Error && error.message.trim()) {
    return error.message.trim();
  }
  return fallback;
};
